<template>
  <div class="contacts-filials">
    <div v-for="country of countries" :key="country.value" class="contacts-filials-country mb-60" :class="country.value">
      <h2 class="vz-text-align-left">{{ getCountryTitle(country.value) }}</h2>
      <nuxt-link :to="country.about" class="contacts-filials-country-link">
        <img class="contacts-filials-country-flag" :src="country.url" :alt="country.name"/>
        <span class="contacts-filials-country-name">{{ country.name }}</span>
        <vz-icon name="arrow-right" class="ml-5" size="18" />
      </nuxt-link>
      <div v-if="locations.length" class="contacts-filials-locations mt-10">
        <nuxt-link
          v-for="(location, index) in countryLocations(country.value)"
          :key="index"
          target="_blank"
          class="contacts-filials-location"
          :to="getLink(location)"
        >
          {{ location.name }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Location } from '~/types/types';
import { useCityStore } from '~/stores/city';
import { phoneCountries } from '~/common/objects';
import { deepCopyObject } from '~/common/functions';

const { rclCityList } = storeToRefs(useCityStore())
const locations = ref([] as Location[])

const countries = computed(() => {
  let result = deepCopyObject(phoneCountries)

  const ruCountry = result.find(country => country.value === 'RU')
  if (ruCountry) {
    ruCountry.about = '/cargo'
  }

  return result.filter(phoneCountry => {
    return countryLocations(phoneCountry.value).length
  })
})

onMounted (async () => {
  locations.value = deepCopyObject(rclCityList.value) as Location[]
})

function countryLocations(country: string): Location[] {
  return locations.value.filter(l => l.country === country)
}

function getCountryTitle(country: String) {
  const title = country === 'RU' 
    ? 'России' 
    : country === 'BY' 
      ? 'Беларуси' 
      : country === 'KZ' 
        ? 'Казахстане'
        : ''
  return title.length ? `Филиалы в ${title}` : '' 
}

function getLink(location: Location) {
  return `/address/${location.translit}/`
}
</script>

<style lang="scss" scoped>
.contacts-filials {
  &-country {
    margin-top: 30px;

    &-link {
      color: $font-low;

      &:hover {
        color: $font-low;
      }
    }

    &-flag {
      width: 20px;
      height: 16px;
    }

    &-name {
      font-size: $fs-18;
      line-height: $fs-26;
      font-weight: 600;
      margin-left: 10px;
      color: $font-low;
    }
  }

  &-locations {
    column-count: 5;

    @media screen and (max-width: $pub-md) {
      column-count: 4;
    }

    @media screen and (max-width: $pub-sm) {
      column-count: 3;
    }

    @media screen and (max-width: $pa-xs) {
      column-count: 2;
    }
  }

  &-location {
    display: block;
    color: $font-low;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-decoration: underline;
    margin-bottom: 8px;
    cursor: pointer;
  }
}
</style>
